module.exports = __webpack_public_path__ + "img/InviteLetterLogo.8fe14940.svg";